import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0253082b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"20px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("全部已读")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("   注：第一次打开太多未读时，可以点全部已读，有新消息没看过时会出现在下方列表 ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_9 = { class: "normal" }
const _hoisted_10 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_11 = { class: "my-header" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "新建任务", -1))
const _hoisted_13 = { class: "qp" }
const _hoisted_14 = { class: "my-header" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务详情", -1))

import { useRouter,useRoute } from 'vue-router';
	import { onMounted,ref,nextTick,computed } from 'vue';
	import { requestNoReadTaskList,requestReadAll } from '@/api/xmApi';
	import AddTask from '@/components/AddTask.vue';
	import TaskDetails from '@/components/TaskDetails.vue'
	
export default /*#__PURE__*/_defineComponent({
  name: 'NewTaskLog',
  setup(__props) {

	const router = useRouter()
	const route = useRoute()
	const list = ref([])
	const loading = ref<boolean>(false)
	const addShowTask = ref<boolean>(false)//添加任务
	const addTask = ref<boolean>(false)
	const taskDetails = ref(false)//控制右侧弹窗
	const taskDetailsShow = ref(false)//控制右侧弹窗
	const form = ref({})

	const taskid = ref(route.params.taskid)
	const yuqi =ref(route.params.yuqi);
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})
	const ReadAllTask  = () => {
		requestReadAll({}).then((res:any)=>{
			if(res.status === 1){
				getTaskList();
			}
		})
	}
	const search = ref({
		status:0,
		projectname:"",
		operatorname:"",
		startdate1:"",
		startdate2:"",
		type1:0,
		liketxt:""
	})
	const type1tostring = (val: number) =>{
		if(val==1){
			return  "项目售前"
		}
		if(val==2){
			return  "项目售中"
		}
		if(val==3){
			return  "项目售后"
		}
		if(val==4){
			return  "公司内部项目"
		}
		if(val==5){
			return  "周计划投产"
		}
	}
	const getStatus = computed(()=>{
		return function(status:number){
			let a = {
				1:"进行中",
				2:"关闭",
				3:"待审核",
				4:"完成"
			}
			return a[status]
		}
	})
	const getType = computed(()=>{
		return function(status:number){
			let b = {
				1:"primary",
				2:"danger",
				3:"warning",
				4:"success"
			}
			return b[status]
		}
	})
	const cancelDetails = () => {
		taskDetails.value = false
		getTaskList()
	}
	const cancelTask = (val:any) =>{
		addShowTask.value = false
		if(val){
			getTaskList()
		}
	}
	const searchList = () =>{
		pageIndex.value = 1
		getTaskList();
	}
	const details = (row:any) => {
		form.value = row
		taskDetailsShow.value = false
		nextTick(()=>{
			taskDetailsShow.value = true
		})
		taskDetails.value = true
	}
	//刷新列表
	const taskListsx = () => {
		getTaskList()
		taskDetails.value = false
	}
	//新建任务
	const createTask = () => {
		tasksx()
		addShowTask.value = true
	}
	const tasksx = () => {
		addTask.value = false
		nextTick(()=>{
			addTask.value = true
		})
	}
	onMounted(()=>{
		getTaskList();
	})
	const getTaskList = () => {
		loading.value = true
		requestNoReadTaskList({}).then((res:any)=>{
			list.value = res.datalist
			loading.value = false
		})
	}
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getTaskList();
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getTaskList();
	}
	const back = () =>{
		router.go(-1)
	}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _ctx.Search,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (ReadAllTask()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["icon"]),
            _hoisted_7
          ])
        ])
      ])
    ]),
    _hoisted_8,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: details,
      data: list.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "任务标题",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_9, _toDisplayString(scope.row.tasktitle), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "operatorname",
          label: "执行人",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "enddate",
          label: "要求完成时间",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "taskdescribe",
          label: "任务描述",
          width: "520"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: addShowTask.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addShowTask).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (addShowTask.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (addTask.value)
          ? (_openBlock(), _createBlock(AddTask, {
              key: 0,
              id: taskid.value,
              onCancelTask: cancelTask
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_dialog, {
        modelValue: taskDetails.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((taskDetails).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (cancelDetails()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (taskDetailsShow.value)
            ? (_openBlock(), _createBlock(TaskDetails, {
                key: 0,
                form: form.value,
                onTaskListsx: taskListsx
              }, null, 8, ["form"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})